/**
 * @typedef {import('hast-util-to-mdast').Options} Options
 */

export {default} from './lib/index.js'
